export default __webpack_public_path__ + "static/valentin_brodsky-650f9dd8a450f4964fe01643f7590247.webp";